import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import AccountLocationsTab from 'components/tabs/AccountLocationsTab';

const LocationsTab = () => (
  <SimpleShowLayout>
    <AccountLocationsTab target="account_id" />
  </SimpleShowLayout>
);

export default React.memo(LocationsTab);
